export default class UserTheme {
    primaryColor?: string = '#860171';
    secondaryColor?: string = '#84c430';
    dark?: boolean = false;
}
